import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PromoService {
    isPromoOpen = false;
    isPromoOpen$ = new BehaviorSubject<boolean>(false);

    openPromo() {
        this.isPromoOpen = true;
        this.isPromoOpen$.next(true);
    }

    closePromo() {
        this.isPromoOpen = false;
        this.isPromoOpen$.next(false);
    }
}
